import { useMemo } from 'react';
import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { buildDefaultValues, buildZodSchema } from 'redesign';
import { DocumentModel } from '@types';

export const useCreateSignDocumentFormSchema = (documentModelsResponse: DocumentModel[string]) => {
  const { t } = useTranslation(['hq-screen-specific']);

  const formSchema = useMemo(() => {
    const baseSchema = z.object({
      documentId: z.string().uuid({
        message: t('document_form.select_document_type', {
          ns: 'hq-screen-specific',
        }),
      }),
      contractHours: z.coerce.number().min(0),
    });

    return buildZodSchema(
      documentModelsResponse.actions.issuer_sign.items,
      documentModelsResponse.actions.issuer_sign.rules,
      (dynamicSchema) => baseSchema.merge(dynamicSchema)
    );
  }, [documentModelsResponse, t]);

  const defaultValues = useMemo(
    () => buildDefaultValues(documentModelsResponse.actions.issuer_sign.items),
    [documentModelsResponse]
  );

  return {
    formSchema,
    defaultValues,
  };
};
